/**
 * @poc-to-production
 *
 * Browser-local Submission Readiness profile per ACC project.
 * Production → Postgres + API (VERA-152).
 */

export type PackageScanMode = "whole-project" | "dedicated-folder";

export interface SrProjectProfile {
  accProjectKey: string;
  permittingAuthorityId: string;
  packageScanMode: PackageScanMode;
  /** DM folder id when packageScanMode === dedicated-folder */
  submissionFolderId?: string;
  submissionFolderLabel?: string;
  /** User-confirmed site line when ACC admin address is missing. */
  siteAddressOverride?: string;
  updatedAt: string;
}

const STORAGE_PREFIX = "vera-sr-profile-v1";

function storageKey(accProjectKey: string): string {
  return `${STORAGE_PREFIX}:${accProjectKey}`;
}

export function accProjectStorageKey(hubId: string, projectId: string): string {
  return `${hubId}::${projectId}`;
}

export function readSrProfile(accProjectKey: string): SrProjectProfile | null {
  if (typeof localStorage === "undefined") return null;
  try {
    const raw = localStorage.getItem(storageKey(accProjectKey));
    if (!raw) return null;
    return JSON.parse(raw) as SrProjectProfile;
  } catch {
    return null;
  }
}

export function writeSrProfile(profile: SrProjectProfile): void {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(
    storageKey(profile.accProjectKey),
    JSON.stringify(profile)
  );
}
